// extracted by mini-css-extract-plugin
export var addButton = "_ik-0";
export var border = "_ik-8";
export var check = "_ik-h";
export var danger = "_ik-6";
export var dropdownContainer = "_ik-1";
export var editModalBody = "_ik-j";
export var footerContainer = "_ik-i";
export var fullWidth = "_ik-a";
export var hide = "_ik-9";
export var icon = "_ik-3";
export var input = "_ik-7";
export var inputFlex = "_ik-b";
export var inputWrapper = "_ik-c";
export var manualFocus = "_ik-5";
export var optionButton = "_ik-4";
export var pillWrapper = "_ik-e";
export var pointer = "_ik-2";
export var showOverflow = "_ik-f";
export var tagsFlex = "_ik-d";
export var xButton = "_ik-g";